// extracted by mini-css-extract-plugin
export default {"menu-link":"MenuLink_menu-link__mJ9LT","menu-link--current":"MenuLink_menu-link--current__tL2uM"};